var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert-box",class:_vm.typeClass},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fal', _vm.typeIcon],"size":"xl"}}),_c('div',[_vm._t("default")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2),(_vm.hasBottomSlot)?_c('div',{staticClass:"bottom"},[_vm._t("bottom")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }